import { WarningColors } from '../../../../foundation/colors/warningColors/warningColors/index.js';
import { SuccessColors } from '../../../../foundation/colors/successColors/successColors/index.js';
import { InformationColors } from '../../../../foundation/colors/informationColors/informationColors/index.js';
import { ErrorColors } from '../../../../foundation/colors/errorColors/errorColors/index.js';
import { NeutralColors } from '../../../../foundation/colors/neutralColors/neutralColors/index.js';
import { GoogleColors } from '../../../../foundation/colors/googleColors/googleColors/index.js';
import { FacebookColors } from '../../../../foundation/colors/facebookColors/facebookColors/index.js';
import { AppleColors } from '../../../../foundation/colors/appleColors/appleColors/index.js';
import { SnapchatColors } from '../../../../foundation/colors/snapchatColors/snapchatColors/index.js';
import { KakaoColors } from '../../../../foundation/colors/kakaoColors/kakaoColors/index.js';
import { LineColors } from '../../../../foundation/colors/lineColors/lineColors/index.js';
import { PrimaryColors } from '../../../../foundation/colors/primaryColors/primaryColors/index.js';
import { PremiumColors } from '../../../../foundation/colors/premiumColors/premiumColors/index.js';
import { NegativeColors } from '../../../../foundation/colors/negativeColors/negativeColors/index.js';
import { PositiveColors } from '../../../../foundation/colors/positiveColors/positiveColors/index.js';
import { SecondaryColors } from '../../../../foundation/colors/secondaryColors/secondaryColors/index.js';
import { AbsolutesWhiteColors } from '../../../../foundation/colors/absolutesWhiteColors/absolutesWhiteColors/index.js';
import { AbsolutesBlackColors } from '../../../../foundation/colors/absolutesBlackColors/absolutesBlackColors/index.js';

const ButtonSkinPrimary = generateButtonSkin(PrimaryColors);
const ButtonSkinSecondary = generateButtonSkin(SecondaryColors);
const ButtonSkinTertiary = generateButtonSkin(NeutralColors);
const ButtonSkinAbsoluteWhite = generateButtonSkin(AbsolutesWhiteColors);
const ButtonSkinAbsoluteBlack = generateButtonSkin(AbsolutesBlackColors);
const ButtonSkinMarket = generateButtonSkin(SecondaryColors);
const ButtonSkinPremium = generateButtonSkin(PremiumColors);
const ButtonSkinStatusError = generateButtonSkin(ErrorColors);
const ButtonSkinStatusSuccess = generateButtonSkin(SuccessColors);
const ButtonSkinStatusWarning = generateButtonSkin(WarningColors);
const ButtonSkinStatusInformation = generateButtonSkin(InformationColors);
const ButtonSkinStatusPositive = generateButtonSkin(PositiveColors);
const ButtonSkinStatusNegative = generateButtonSkin(NegativeColors);
const ButtonSkinStatusHighLight = generateButtonSkin(InformationColors);
const ButtonSkinExternalBrandGoogle = generateButtonSkin(GoogleColors);
const ButtonSkinExternalBrandFacebook = generateButtonSkin(FacebookColors);
const ButtonSkinExternalBrandApple = generateButtonSkin(AppleColors);
const ButtonSkinExternalBrandSnapchat = generateButtonSkin(SnapchatColors);
const ButtonSkinExternalBrandKakao = generateButtonSkin(KakaoColors);
const ButtonSkinExternalBrandLine = generateButtonSkin(LineColors);
function generateButtonSkin(colorPackage) {
    return {
        base: colorPackage.base.default,
        baseAction: colorPackage.base.action,
        baseActive: colorPackage.base.active,
        baseActiveAction: colorPackage.base.activeAction,
        text: colorPackage.text.default,
        textAction: colorPackage.text.action,
        textActive: colorPackage.text.active,
        textActiveAction: colorPackage.text.activeAction,
    };
}

export { ButtonSkinAbsoluteBlack, ButtonSkinAbsoluteWhite, ButtonSkinExternalBrandApple, ButtonSkinExternalBrandFacebook, ButtonSkinExternalBrandGoogle, ButtonSkinExternalBrandKakao, ButtonSkinExternalBrandLine, ButtonSkinExternalBrandSnapchat, ButtonSkinMarket, ButtonSkinPremium, ButtonSkinPrimary, ButtonSkinSecondary, ButtonSkinStatusError, ButtonSkinStatusHighLight, ButtonSkinStatusInformation, ButtonSkinStatusNegative, ButtonSkinStatusPositive, ButtonSkinStatusSuccess, ButtonSkinStatusWarning, ButtonSkinTertiary };
